// colors.js

export const purple = {
  100: "#f0e6ff",
  200: "#d1bfff",
  300: "#b394ff",
  400: "#945eff",
  500: "#7b1fff", // primary accent purple (hover)
  600: "#5800cc",
  700: "#3e0099",
  800: "#29004b", // card bg
  900: "#1b0036", // main bg
};
export const orange = {
  100: "#ffe6cc",
  200: "#ffbf80",
  300: "#ff9933",
  400: "#ff8000",
  500: "#ff7300", // primary accent orange
  600: "#cc5c00",
  700: "#994400",
  800: "#662d00",
  900: "#331600",
};

export const gray = {
  100: "#f9f9f9",
  200: "#eaeaea",
  300: "#cfcfcf",
  400: "#b1b1b1",
  500: "#969696",
  600: "#757575",
  700: "#5a5a5a",
  800: "#3b3b3b",
  900: "#1c1c1c",
};

export const white = "#ffffff";
export const black = "#000000";
export const background = "#31065A";
